import { doGET } from '../../utils/HttpUtils';
import { InvoiceFilters, InvoiceListResult } from '../../types/invoices';

const cleanQuery = (values: Record<string, unknown>) =>
    Object.fromEntries(
        Object.entries(values).filter(([, value]) => value !== undefined && value !== '')
    );

export const fetchInvoices = async (
    filters: InvoiceFilters,
    page = 1,
    limit = 20,
    exportAll = false
): Promise<InvoiceListResult> => {
    const query = new URLSearchParams(cleanQuery({
        ...filters,
        page,
        limit,
        export: exportAll || undefined,
    }) as Record<string, string>);
    const response = await doGET(`/payments/invoices?${query.toString()}`);

    if (!(response.status >= 200 && response.status < 400)) {
        throw new Error(response?.data?.message || response?.message || 'Failed to fetch invoices');
    }

    return {
        rows: Array.isArray(response.data?.data) ? response.data.data : [],
        total: response.data?.pagination?.total || 0,
        totalPages: response.data?.pagination?.totalPages || 0,
        summary: response.data?.summary || {
            baseAmount: 0,
            discountAmount: 0,
            walletAmount: 0,
            finalAmount: 0,
        },
    };
};
